import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        textAlign: 'center',
        padding: theme.spacing(4),
        flexGrow:'1',
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        [theme.breakpoints.down('sm')]: {
            padding: '0px',
            paddingTop:'40px',
            width:'100vw',
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        marginTop: '50px !important',
        marginBottom:'30px !important',
        fontSize: '35px',
        textAlign:'center',
    },
    subtitle: {
        color: '#EE6628',
        fontSize: '26px',
    },
    cardHeader:{
        width: '100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'flex-start',
        paddingTop:'20px',
        height: '200px',
        background: 'linear-gradient(to bottom right, #6A8EC9 0%, #8C74A7 30%, #D44C71 66%, #C91C6E 103%)',
        borderBottomLeftRadius: '100% 50px',
        borderBottomRightRadius: '100% 50px',
        overflow: 'hidden',
        position: 'relative',
    },
    card:{
        width:'340px',
        padding:'0px !important',
        position:'relative',
        backgroundColor:'#fff',
        margin:'25px',
        height:'530px',
        display:'flex',
        flexDirection:'column',
        borderRadius:'15px !important',
        alignItems:'center',
        textAlign:'center',
        [theme.breakpoints.down('sm')]: {
            width: '315px',
        },
        [theme.breakpoints.up('lg')]: {
            margin: '9px',
        },
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
        height: '100%',
        width:'100%',
        padding: '0px !important',
    },
    button: {
        margin: '10px !important',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        width: '100% !important',
        padding: '10px !important',
        color: '#fff !important',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
            color: '#fff !important',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '10px 0 !important',
        },
    },
    upgradeButton: {
        position: 'absolute !important',
        top: '0px !important',
        right: '0px !important',
        backgroundColor: '#002060 !important',
        color: '#FFFFFF !important',
        zIndex: 2,
        '&:hover': {
            backgroundColor: '#00153b !important',
        },
    },
    // disabledCard: {
    //     backgroundColor: '#D8D8D8 !important',
    //     color: '#606060 !important',
    //     '& h5, & p': {
    //         color: '#606060 !important',
    //     },
    //     '& $button': {
    //         backgroundColor: '#606060 !important',
    //         color: '#fff !important',
    //         border: 'none !important',
    //         '&:hover': {
    //             backgroundColor: '#505050 !important',
    //         },
    //     },
    // },
    enabledCard: {
        backgroundColor: '#fff',
        color: '#000',
    },
    activeButton: {
        backgroundColor: "linear-gradient(to bottom, #FFAC46 0%, #FF5979 50%, #E7466E 100%)",
        color: '#fff !important',
    },

}));

export default useStyles;